import { createContext, useContext } from "react"
export type TUserAddressContext = string | undefined;
export const UserAddressContext = createContext<TUserAddressContext>(undefined);
export const useUserAddressContext = () => useContext(UserAddressContext);
